import { useQuery } from "@tanstack/react-query";
import { companyCityOptionsQueryKey } from "../utils/companyFilterOptionQueryKeys";

type SelectOption = {
  value: string;
  label: string;
};
export default function useCityOptions(companyId: string | null): {
  cityOptions: SelectOption[];
  isPending: boolean;
} {
  const cityOptionsQuery = useQuery<string[]>({
    queryKey: companyCityOptionsQueryKey(companyId),
    enabled: companyId !== null,
  });
  const cityOptions = cityOptionsQuery.isPending
    ? []
    : cityOptionsQuery.data?.map((o) => {
        return { value: o, label: o };
      }) ?? [];
  return { cityOptions, isPending: cityOptionsQuery.isPending };
}
